import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';
import {Observable} from 'rxjs';
import {BE_API_URL} from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class LogService {

  constructor(private http: HttpClient, private authService: AuthService) {}

  getLogs(): Observable<any> {
    const headers = this.authService.createAuthorizationHeader();
    return this.http.get(`${BE_API_URL}/auth/logs`, { headers })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
